
import messageSound from "../assets/audio/message.mp3";
import Notification1 from "../assets/audio/Message/notification1.mp3"
import Notification2 from "../assets/audio/Message/notification2.mp3"
import Notification3 from "../assets/audio/Message/notification3.mp3"
import Notification4 from "../assets/audio/Message/notification3.mp3"
import soundCalling from "../assets/audio/oppo.mp3"

const LIST_SOUND_MESSAGE = {
    Notification1,
    Notification2,
    Notification3,
    messageSound,
   

};
const LIST_SOUND_CALLING = {
    soundCalling
};
export const onMusicByType = (type, volume) => {
    
    const audio = document.createElement("audio");
    audio.style.display = "none";
    audio.src = LIST_SOUND_MESSAGE[type] ? LIST_SOUND_MESSAGE[type] : Notification1;
    audio.autoplay = true;
    audio.volume = typeof (volume) !== "undefined" ? volume * 0.2 : 1;
    audio.onended = () => audio.remove();
    document.body.appendChild(audio);
}
export const handleMusicCalling = (status) => {
   
    if(status){
        const audio = document.createElement("audio");
        audio.className = "sound_calling";
        audio.style.display = "none";
        audio.src = soundCalling;
        audio.autoplay = true;
        audio.onended = () => audio.remove();
        document.body.appendChild(audio);
    }else{
        document.querySelectorAll(".sound_calling").forEach(el => el.remove());
    }
   
}